import type { InputHTMLAttributes } from "react";

interface LabeledInputProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
> {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

/**
 * Поле ввода с подписью в стандартной разметке форм ERP (`label.field`).
 *
 * Оборачивает `<input>` в подпись, чтобы форма не повторяла на каждом поле одни
 * и те же четыре строки, и отдаёт наружу значение, а не событие. Все остальные
 * атрибуты (`type`, `autoComplete`, `required`, `minLength`…) передаются полю
 * как есть. Подходит простым формам входа, восстановления и смены пароля; поля
 * с подсказкой и ошибкой под ними — это `TextField`.
 */
export function LabeledInput({
  label,
  value,
  onChange,
  ...input
}: LabeledInputProps) {
  return (
    <label className="field">
      <span>{label}</span>
      <input
        {...input}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </label>
  );
}
